export const LOCALE_PREFIX = 'scenes.Gnosus.components.Toolbar'

export const TOOLBAR_ICON_CLICK = 'TOOLBAR_ICON_CLICK'
export const TOOLBAR_OUTSIDE_CLICK = 'TOOLBAR_OUTSIDE_CLICK'

export const WITHOUT_TAB = 'withoutTab'
